import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import { PrivateRoute } from "@/components/layout/PrivateRoute";
import { ErrorBoundary } from "@/components/layout/ErrorBoundary";

const HomePage = lazy(() => import("@/pages/HomePage"));
const SearchPage = lazy(() => import("@/pages/SearchPage"));
const CompanyPage = lazy(() => import("@/pages/CompanyPage"));
const CVAnalyserPage = lazy(() => import("@/pages/CVAnalyserPage"));
const SalaryCheckerPage = lazy(() => import("@/pages/SalaryCheckerPage"));
const OnboardingPage = lazy(() => import("@/pages/OnboardingPage"));
const DashboardPage = lazy(() => import("@/pages/DashboardPage"));
const CommunityPage = lazy(() => import("@/pages/CommunityPage"));
const PricingPage = lazy(() => import("@/pages/PricingPage"));
const LoginPage = lazy(() => import("@/pages/LoginPage"));
const RegisterPage = lazy(() => import("@/pages/RegisterPage"));
const LegalPage = lazy(() => import("@/pages/LegalPage"));
const InterviewCoachPage = lazy(() => import("@/pages/InterviewCoachPage"));
const VisaAdvisorPage = lazy(() => import("@/pages/VisaAdvisorPage"));
const TrackerPage = lazy(() => import("@/pages/TrackerPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));
const ForgotPasswordPage = lazy(() => import("@/pages/ForgotPasswordPage"));
const ResetPasswordPage = lazy(() => import("@/pages/ResetPasswordPage"));

const Loading = () => (
  <div className="min-h-screen bg-black flex items-center justify-center">
    <div className="w-6 h-6 border-2 border-primary/20 border-t-primary rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ErrorBoundary>
        <AuthProvider>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/company/:id" element={<CompanyPage />} />
              <Route path="/salary-checker" element={<SalaryCheckerPage />} />
              <Route path="/community" element={<CommunityPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/privacy" element={<LegalPage />} />
              <Route path="/terms" element={<LegalPage />} />
              <Route path="/data-sources" element={<LegalPage />} />
              <Route path="/contact" element={<LegalPage />} />
              <Route path="/cv-analyser" element={<PrivateRoute><CVAnalyserPage /></PrivateRoute>} />
              <Route path="/onboarding" element={<PrivateRoute><OnboardingPage /></PrivateRoute>} />
              <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
              <Route path="/interview-coach" element={<PrivateRoute><InterviewCoachPage /></PrivateRoute>} />
              <Route path="/visa-advisor" element={<PrivateRoute><VisaAdvisorPage /></PrivateRoute>} />
              <Route path="/tracker" element={<PrivateRoute><TrackerPage /></PrivateRoute>} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </AuthProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
